export const API_ROUTES = {
	GET: {
		PRIVATE: {
			GET_ALL_POSTS: '/partner/posts',
			GET_REWARD_BY_ID: '/partner/rewards/:reward_id',
			GET_ALL_SCORES: '/partner/user-points',
			GET_USER_POINT_BY_PROPOSAL: '/partner/user-points/by-proposal/:proposalNumber',
			GET_USER_BY_KEYCLOAK_ID: '/partner/users/keycloak/:keycloak_id',
			GET_SEASON_BY_ID: '/partner/seasons/:season_id',
			GET_USER_SEASON_SCORE: '/partner/season-scores/:season_id',

			GET_ALL_SEASON_RANKINGS: '/partner/season-rankings',
			GET_ALL_REWARDS: '/partner/rewards',
			GET_ALL_RANKINGS: '/partner/rankings',
			GET_ALL_SEASON_SCORES: '/partner/season-scores',
			GET_ALL_PRODUCTS: '/partner/products',
			GET_ALL_SEASONS: '/partner/seasons',
			GET_PARTNER_PROGRESS_SUMMARY: '/partner/progress/summary',
			GET_CLOSED_PROPOSALS_CHART: '/partner/progress/closed-proposals-chart',
			GET_ALL_STAMPS: '/partner/stamps',
		},
		PUBLIC: {
			GET_USER_SEASON_SCORE: '/public/season-scores/:season_id/user/:user_id',
			GET_USER_BY_PROFILE_URL: '/public/users/profile/:profile_url',
			GET_MEDIA_BLOB: '/public/media/:media_id',
			GET_CURRENT_SEASON: '/public/seasons/current',
			GET_ALL_FAQS: '/public/faqs',
			GET_ALL_BANNERS: '/public/banners',
			GET_ALL_SHOWROOMS: '/public/showroom',
		},
		AUTH: {
			GET_LOGIN_URL: '/auth/keycloak/partner/get-login-url',
			GET_LOGOUT_URL: '/auth/keycloak/partner/get-logout-url',
		},
	},
	POST: {
		PRIVATE: {
			CREATE_MEDIA: '/partner/media',
			CREATE_USER_ADDRESS: '/partner/user-addresses',
			CLAIM_REWARD: '/partner/redeem-products/:reward_id',
		},
		PUBLIC: {
			CREATE_PRE_REGISTRATION: '/public/pre-registrations',
		},
		AUTH: {
			REFRESH_TOKEN: '/auth/keycloak/partner/refresh',
			VERIFY_CREDENTIALS: '/auth/keycloak/partner/verify-credentials',
		},
	},
	PUT: {
		PRIVATE: {},
	},
	PATCH: {
		PRIVATE: {
			UPDATE_USER: '/partner/users',
			UPDATE_MEDIA: '/partner/media/:media_id',
			UPDATE_USER_ADDRESS: '/partner/user-addresses/:address_id',
		},
	},
	DELETE: {
		PRIVATE: {
			DELETE_USER_ADDRESS: '/partner/user-addresses/:address_id',
		},
		AUTH: {},
	},
} as const;
